var option_default = {
  "option": "_4e9RJ",
  "user_choice": "up3h5",
  "check": "gVDQN",
  "image": "_7YK7I",
  "input": "-ATAw",
  "title": "ugQmL",
  "centered": "eBjbe",
  "with_result": "PP6MU",
  "list": "HuYaV",
  "with_image": "_3m9Hs",
  "progress": "p2m8t",
  "progress_value": "O1yoR",
  "label": "vjLPH",
  "cta": "nVHA2",
  "adornment_icon": "oQmE7",
  "remove": "sMbp9",
  "removeButton": "p3SIl",
  "removeButtonIcon": "Y1knz",
  "overlay": "bX-jt",
  "shown": "OK99h",
  "dark": "ZhZpC",
  "spinner": "B--rq",
  "spin": "SmsTL"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
